import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { main_links } from 'config';
import { CartContext } from '../../cart/CartContext';
import './style.scss';


const ProcessChange = ( {category="",valueCopy=false} ) => {

    const { cartData } = useContext(CartContext);
    const [hasCouponsCart, setHasCouponsCart] = useState(false);
    const [pathRedirect, setPathRedirect] = useState('');
    const redirectConfirmation = (event) => {
        event.preventDefault();
        setPathRedirect(main_links.cart);
    }
    useEffect(() => {
        if(category!=="ecommerce" && cartData?.state==='A' && cartData.items.length){
            setHasCouponsCart(true);
        } else {
            setHasCouponsCart(false);
        }
    }, [cartData]);


    return (
        <>
        {hasCouponsCart 
            && 
            <>
            <section className="coupons-buttons">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p className="text-center mt-3 mb-3">
                                <a href="#" onClick={(event) =>{ redirectConfirmation(event)}} className="btn button-change-coupons black">Ir a Canjear cupones</a>
                            </p>
                        </div>
                    </div>
                   
                </div>
             
            </section>
            
            {pathRedirect!=='' && <Redirect to={pathRedirect} />}
            
            </>
        }
        {valueCopy
            &&
            <>
            <section className="coupons-buttons-ecommerce">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className="text-center mt-3 mb-3">
                                <a href="https://www.metro.pe/" target={'_blank'} rel="noreferrer" className="btn button-change-coupons black ">Ir a Metro.pe</a>
                            </p>
                           
                        </div>
                        <div className="col">
                        <p className="text-center mt-3 mb-3">
                                <a  href="https://linktr.ee/appmetro" target={'_blank'} rel="noreferrer" className="btn button-change-coupons black" >Ir a APP Metro</a>
                            </p>

                        </div>
                    </div>
                   
                </div>
             
            </section>
            
            {pathRedirect!=='' && <Redirect to={pathRedirect} />}
            
            </>

        }
        </>
    );
};

ProcessChange.propTypes = {
    category: PropTypes.string,
    controlLimiteHCanjear: PropTypes.func,
    valueCopy:PropTypes.bool
};

export default ProcessChange;